module.exports = __webpack_public_path__ + "img/hunt_tag.8861470c.png";